import React from 'react';

import { Row } from 'reactstrap';
import DonutContainer from 'components/containers/DonutContainer';
import CarouselContainer from 'components/containers/CarouselContainer';
import HorizontalBarChartContainer from 'components/containers/HorizontalBarChartContainer';
import TrendContainer from 'components/containers/TrendContainer';
import PlaneContainer from 'components/containers/PlaneContainer';
import TableContainer from 'components/containers/TableContainer';

let page = 'tv-series';
let displayPageName = 'TV Series';

class TVSeriesOverview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidUpdate(prevProps, prevState) {}

    async componentDidMount() {}

    render() {
        let dashboard = (
            <div>
                <CarouselContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    contentType="TV Series"
                    forceReloadAll={this.props.forceReloadAll}
                    title="TV Rankings"
                    workbenchTitle="titles"
                    page={page}
                    pageName={displayPageName}
                    tabFunction={this.props.tabFunction}
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    subscription={this.props.subscription}
                    app={this.props.app}
                    subscriptionStage={this.props.subscriptionStage}
                />

                <Row>
                    <DonutContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        renderType="row"
                        forceReloadAll={this.props.forceReloadAll}
                        page={page}
                        pageName={displayPageName}
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        allowedApps={this.props.allowedApps}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>

                <TrendContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    contentType="TV Series"
                    forceReloadTrend={this.props.forceReloadTrend}
                    forceReloadAll={this.props.forceReloadAll}
                    title="Trends"
                    workbenchTitle="trends"
                    page={page}
                    pageName={displayPageName}
                    key="tv_series_overview_trend_1"
                    id="tv_series_overview_trend_1"
                    tabFunction={this.props.tabFunction}
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    subscription={this.props.subscription}
                    app={this.props.app}
                    subscriptionStage={this.props.subscriptionStage}
                />

                <PlaneContainer
                    path={this.props.path}
                    appliedFilters={this.props.appliedFilters}
                    contentType="TV Series"
                    title="Cabin Class"
                    workbenchTitle="cabin_class_viewing"
                    page={page}
                    pageName={displayPageName}
                    forceReloadAll={this.props.forceReloadAll}
                    tabFunction={this.props.tabFunction}
                    showWorkbenchLink={this.props.showWorkbench}
                    tenantIcaoCode={this.props.tenantIcaoCode}
                    subscription={this.props.subscription}
                    app={this.props.app}
                    subscriptionStage={this.props.subscriptionStage}
                />

                <Row>
                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="TV Series"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Routes"
                        workbenchTitle="routes"
                        page="tv-series"
                        pageName={displayPageName}
                        reportType="routes"
                        color="#F7A77F"
                        routes={true}
                        key="tv_series_overview_routes_1"
                        id="tv_series_overview_routes_1"
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />

                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="TV Series"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Categories"
                        workbenchTitle="categories"
                        page="tv-series"
                        pageName={displayPageName}
                        reportType="categories"
                        color="#77AFD7"
                        key="tv_series_overview_categories_1"
                        id="tv_series_overview_categories_1"
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>

                <Row>
                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="TV Series"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Genres"
                        workbenchTitle="genres"
                        page="tv-series"
                        pageName={displayPageName}
                        reportType="genres"
                        color="#954F95"
                        key="tv_series_overview_genres_1"
                        id="tv_series_overview_genres_1"
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />

                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="TV Series"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Languages"
                        workbenchTitle="languages"
                        page="tv-series"
                        pageName={displayPageName}
                        reportType="languages"
                        color="#7FCECD"
                        key="tv_series_overview_languages_1"
                        id="tv_series_overview_languages_1"
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>

                <Row>
                    <HorizontalBarChartContainer
                        path={this.props.path}
                        appliedFilters={this.props.appliedFilters}
                        contentType="TV Series"
                        forceReloadAll={this.props.forceReloadAll}
                        title="Airlines"
                        workbenchTitle="airlines"
                        page={page}
                        pageName={displayPageName}
                        reportType="airlines"
                        color="#7FCECD"
                        key="tv_series_overview_airlines_1"
                        id="tv_series_overview_airlines_1"
                        tabFunction={this.props.tabFunction}
                        showWorkbenchLink={this.props.showWorkbench}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                        subscription={this.props.subscription}
                        app={this.props.app}
                        subscriptionStage={this.props.subscriptionStage}
                    />
                </Row>
                <Row>
                    <TableContainer
                        pageName={displayPageName}
                        data={this.props.data}
                        dataset={this.props.dataset}
                        loading={this.props.loading}
                        appliedFilters={this.props.appliedFilters}
                        title="TV Series"
                        app={this.props.app}
                        tenantIcaoCode={this.props.tenantIcaoCode}
                    />
                </Row>
            </div>
        );

        return <div>{dashboard}</div>;
    }
}

export default TVSeriesOverview;
